// ============================= Direct S3 Upload =============================================

import axios from "axios";
import { mediaApi } from "../api/mediaApi";

export const uploadToS3 = async ({ file, mediaType, onProgress, signal }) => {
  if (!file) {
    throw new Error("uploadToS3: 'file' is required");
  }

  const contentType = file.type || "application/octet-stream";

  const presign = await mediaApi.getUploadUrl({
    fileName: file.name,
    contentType,
    mediaType,
    fileSize: file.size,
  });

  const { uploadUrl, key } = presign || {};

  if (!uploadUrl || !key) {
    throw new Error(
      `uploadToS3: presign response missing "uploadUrl" or "key" for "${file.name}". Check that /media/presign returns both fields.`
    );
  }

  try {
    await axios.put(uploadUrl, file, {
      headers: {
        "Content-Type": contentType,
        "x-amz-acl": "public-read",
      },
      signal, // optional AbortController signal, lets callers cancel an in-flight upload

      onUploadProgress: (event) => {
        if (!event.total) return;

        const percent = Math.round((event.loaded * 100) / event.total);

        onProgress?.(percent);
      },
    });
  } catch (error) {
    throw new Error(
      `uploadToS3: upload to S3 failed for "${file.name}": ${error.message}`
    );
  }

  return key;
};




// ===============================================================================================

// import axios from "axios";
// import { mediaApi } from "../api/mediaApi";

// export const uploadToS3 = async ({ file, mediaType, onProgress }) => {
//   const presign = await mediaApi.getUploadUrl({
//     fileName: file.name,
//     contentType: file.type,
//     mediaType,
//     fileSize: file.size,
//   });

//   const { uploadUrl, key } = presign;

//   await axios.put(uploadUrl, file, {
//     headers: {
//       "Content-Type": file.type,
//     },

//     onUploadProgress: (event) => {
//       if (!event.total) return;

//       const percent = Math.round((event.loaded * 100) / event.total);

//       onProgress?.(percent);
//     },
//   });

//   return key;
// };
